import MaterialMaster from './MaterialMaster';
import MaterialMasterForm from './MaterialMasterForm';

const MaterialMasterConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/materialMasters',
            element: <MaterialMaster />,
        },
        {
            path: '/addMaterialMaster-product',
            element: <MaterialMasterForm />,
        },
        {
            path: '/editMaterialMaster-product/:id',
            element: <MaterialMasterForm />,
        },
    ],
};

export default MaterialMasterConfig;
